import React from 'react';

const UnsBackgroundBox = ({ data }) => {
  return (
    <div
      style={{
        width: data.width,
        height: data.height,
        border: '2px solid #FFFFFF26',
        borderRadius: '8px',
        backgroundColor: '#203D5E',
        position: 'relative',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '10px',
          left: '15px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          pointerEvents: 'none',
        }}
      >
        {data.imageUrl && (
          <img 
            src={data.imageUrl} 
            alt={data.label}
            style={{
              height: '24px',
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        )}
        <span
          style={{
            color: 'white',
            fontSize: '18px',
            fontWeight: 'bold',
          }}
        >
          {data.label}
        </span>
      </div>
    </div>
  );
};

export default UnsBackgroundBox;

